// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressBar_progressBar__12KyT","active":"ProgressBar_active__NqUQk","completed":"ProgressBar_completed__13Xrk"};